<template>
  <v-text-field
    ref="intInput"
    @blur="finishEdit"
    v-model="newValue"
    @keydown="checkKey"
    v-if="readonly != 'RO'"
    :readonly="readonly == 'WR' ? false : true"
    :label="required ? fieldlabel + $t('cabledesign.required') : fieldlabel"
    :suffix="suffix"
    :hide-details="hidedetails"
    class="mt-0 pt-0"
  ></v-text-field>
  <div v-else>{{ fieldlabel }}: {{ newValue != null ? newValue + " " + suffix : $t('cabledesign.notFilled') }}</div>
</template>

<script>
import { isEmpty } from "lodash";

export default {
  props: ["value", "readonly", "fieldlabel", "suffix", "required", "hidedetails"],
  data() {
    return {
      newValue: this.value
    };
  },
  watch: {
    value() {
      this.newValue = this.value;
    }
  },
  methods: {
    checkKey(event) {
      this.$log.debug("--- CHECKKEY ---");
      var keyCode = event.which || event.keyCode;
      var otherKey = event.metaKey || event.altKey || event.ctrlKey;

      var ref = this.$refs.intInput;
      var myinput = ref.$el.querySelector("input");
      this.$log.debug("ref:", ref);
      var cursorPosition = myinput.selectionStart;
      this.$log.debug("cursorPos:" + cursorPosition);

      var val = this.newValue;
      this.$log.debug("1: NEWVALUE: " + val);

      /* Functional, Navigational and Number Keys */
      if (
        otherKey ||
        (keyCode < 48 && (keyCode != 32) & (keyCode != 8)) ||
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 91 && keyCode <= 93) ||
        (keyCode >= 96 && keyCode <= 105) ||
        (keyCode >= 112 && keyCode <= 145) ||
        (keyCode == 173 && cursorPosition == 0)
      ) {
        return;
      } else {
        if (keyCode == 8) {
          /* Delete digit */
        } else if (keyCode == 109 || keyCode == 189) {
          if (cursorPosition != 0 || (!isEmpty(val) && String(val[0]) == "-")) {
            event.preventDefault();
          }
        } else {
          event.preventDefault();
        }
      }
    },
    finishEdit() {
      this.$log.debug("INT emitting new value: " + this.newValue);
      var val = this.newValue === "" ? null : this.newValue;
      this.$emit("change", val);
    }
  },
  mounted: function() {
    if (this.readonly != "RO") {
      var ref = this.$refs.intInput;
      this.$nextTick(function() {
        // Code that will run only after the
        // entire view has been rendered
        var myinput = ref.$el.querySelector("input");
        myinput.addEventListener("paste", event => {
          event.preventDefault();
        });
      });
    }
  }
};
</script>
